module.exports = __webpack_public_path__ + "static/eid99.svg-ba7d98cbf5db5b24359e502b70c62f98.png";